import BillingTable from "./BilingTable";

export default BillingTable;